import { Wrapper } from './styles';

import CircularProgress from '@material-ui/core/CircularProgress';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional
 */
import { useEffect } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 * 
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useMap, useModule } from 'views/MapView/hooks';

export const Map = (props) => {
  const { loadingInMap, initializeMap } = useMap();
  const { activeModule } = useModule();

  useEffect(() => {
    const mapDiv = document.createElement('div');
    mapDiv.id = 'map';
    const mapContainer = document.getElementById('map-comtainer');
    mapContainer.appendChild(mapDiv);
    initializeMap();
    return () => mapContainer.removeChild(mapDiv);
  }, [initializeMap, activeModule]);

  return (
    <Wrapper id="map-comtainer">
      {loadingInMap && (
        <div className="loader">
          <CircularProgress color="inherit" />
        </div>
      )}
    </Wrapper>
  );
};

Map.properties = {
  id: 'CPN-MA-MAP',
  alias: 'Mapa',
  description: '...',
  required: true,
  configurable: true,
  shouldConfigure: true,
};

export default Map;
